'use client';

import { useState } from 'react';
import {
    Title,
    Button,
    Input,
    Stack,
    Card,
    Group,
    Image,
    Text,
    Box,
} from '@mantine/core';
import Link from 'next/link';
import { IconPlus, IconSearch } from '@tabler/icons-react';
import { usePathname } from 'next/navigation';
import { Locale } from '@/i18n-config';
import classes from './AdminDashboardPanel.module.scss';

interface ArticleCard {
    id: string;
    title: string;
    description: string | Record<string, string>;
    imageUrl: string;
    link: string;
}

interface AdminDashboardPanelProps {
    total: number;
    createUrl: string;
    cards: ArticleCard[];
    titleLabel?: string;
    createButtonLabel?: string;
    createButtonVisible?: boolean;
    seeMoreVisible?: boolean;
    seeMoreRedirect?: string;
    seeMoreLabel?: string;
    maxCards?: number;
}

const AdminDashboardPanel: React.FC<AdminDashboardPanelProps> = ({
    total,
    createUrl,
    cards,
    titleLabel = 'Total',
    createButtonLabel = 'Page de gestion',
    createButtonVisible = true,
    seeMoreVisible = false,
    seeMoreRedirect = '',
    seeMoreLabel = 'Voir plus',
    maxCards = 3,
}) => {

    console.log(createButtonLabel)
    const [search, setSearch] = useState('');
    const pathname = usePathname();
    const locale = pathname.split('/')[1] as Locale;

    const filteredCards = cards.filter((card) =>
        card.title.toLowerCase().includes(search.toLowerCase())
    );

    const displayCards = filteredCards.slice(0, maxCards);

    return (
        <Stack gap="lg" className={classes.panelWrapper}>
            <Group justify="space-between" align="center">
                <Title order={2} className={classes.title}>
                    {titleLabel}: {total}
                </Title>
                <Group>
                    {createButtonVisible && (
                        <Button
                            leftSection={<IconPlus size={16} />}
                            component={Link}
                            href={createUrl}
                            className={classes.createButton}
                        >
                            {createButtonLabel}
                        </Button>
                    )}
                    {seeMoreVisible && (
                        <Button
                            variant="outlined"
                            component={Link}
                            href={seeMoreRedirect}
                            className={classes.seeMoreButton}
                            fullWidth={false}
                        >
                            {seeMoreLabel}
                        </Button>
                    )}
                </Group>

            </Group>

            <Input
                // @ts-ignore
                icon={<IconSearch size={16} />}
                placeholder="Rechercher..."
                value={search}
                onChange={(e) => setSearch(e.currentTarget.value)}
                className={classes.searchInput}
            />

            <Stack>
                {displayCards.map((card) => (
                    <Link
                        key={card.id}
                        href={card.link}
                        className={classes.cardLink}
                    >
                        <Card withBorder radius="md" p="md" shadow="sm" className={classes.card}>
                            <Group justify="space-between" align="center" wrap="nowrap">
                                <Box className={classes.cardContent}>
                                    <Text fw={600} className={classes.cardTitle}>
                                        {card.title}
                                    </Text>
                                    <Text c="dimmed" size="sm" lineClamp={2}>
                                        {typeof card.description === 'string'
                                            ? card.description
                                            : card.description[locale] || ''}
                                    </Text>
                                </Box>
                                <Image
                                    src={card.imageUrl}
                                    alt={card.title}
                                    w={120}
                                    h={80}
                                    fit="cover"
                                    radius="md"
                                    className={classes.cardImage}
                                />
                            </Group>
                        </Card>
                    </Link>
                ))}

                {filteredCards.length > maxCards && <p>...</p>}
            </Stack>
        </Stack>
    );
};

export default AdminDashboardPanel;
